module.exports = __webpack_public_path__ + "static/media/file-icon.f31879ba.svg";